import { IProfile, IProtocolData, IUser } from "../../store/api/admin/types";
import { ISiteGroup } from "../../store/api/devices/types";
import { titleCase } from "../../utils/helpers";

export const getProfileList = (data: IProfile[]) => [
  ...data.map((item: IProfile, index: number) => ({
    text: titleCase(item.name),
    value: item.id?.toString() || index.toString(),
  })),
];

export const getProtocolList = (data: IProtocolData[]) =>
  data.map((item: IProtocolData, index: number) => ({ text: item.name, value: item.value?.toString() || index.toString() }));

export const getProfileListForReplace = (data: IProfile[], profileId: number) => [
  ...getProfileList(data).filter((item: any, index: number) => item.value !== profileId.toString()),
];

export const getUserList = (data: IUser[]) => data.map((item: IUser) => item.username);
export const getUserListForSelect = (data: IUser[]) =>
  data.map((item: IUser, index: number) => ({ text: item.username, value: item?.id?.toString() || index.toString() }));

export const getBandDataList = (data: string[]) =>
  data.map((item: string, index: number) => ({ text: item, value: item?.toString() || index.toString() }));

export const getGroupList = (data: ISiteGroup[]) =>
  data.map((item: ISiteGroup, index: number) => ({ text: item.name, value: item.objectKey?.toString() || index.toString() }));
